import React from 'react';
import { Trans } from 'react-i18next';
import { Hint } from '../../../components/Hint';
import { ExchangeModalLink } from '../../../components/ExchangeModalLink';

export const Warning: React.FC = () => (
  <Hint>
    <Trans i18nKey="toAlfaBank:You can withdraw only rubles to an account of Alfa-Bank">
      You can withdraw only rubles to an account of Alfa-Bank. To do this{' '}
      <ExchangeModalLink>exchange dollars for rubles</ExchangeModalLink>. Orders are executed on
      weekdays.
    </Trans>
  </Hint>
);
